import { slicedToArray as _slicedToArray } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState } from 'react';
import { TextField } from '@deal/components';
import isValidNumber from '../isValidNumber.js';
import styles from './styles.css.js';

var LengthInInches = function LengthInInches(_ref) {
  var disabled = _ref.disabled,
      numericValue = _ref.numericValue,
      onLengthUpdated = _ref.onLengthUpdated,
      fieldError = _ref.fieldError;

  /**
   * Does the number pass a regex check and is it greater than zero
   */
  var isLengthValueInvalid = function isLengthValueInvalid(value) {
    return !isValidNumber(value) || parseInt(value, 10) < 0;
  };

  var feetToInches = function feetToInches(feet, inches) {
    return feet * 12 + inches;
  };
  /**
   * Parse a value of inches FT and IN
   */


  var inchesToFeetAndInches = function inchesToFeetAndInches(heightInInches) {
    if (!heightInInches) {
      return undefined;
    }

    var parsedInches = typeof heightInInches === 'string' ? parseInt(heightInInches, 10) : heightInInches;
    return {
      feet: Math.floor(parsedInches / 12),
      inches: parsedInches % 12
    };
  };

  var parsedInitialValue = inchesToFeetAndInches(numericValue);

  var _useState = useState(parsedInitialValue && parsedInitialValue.feet.toString()),
      _useState2 = _slicedToArray(_useState, 2),
      lengthInFeet = _useState2[0],
      setLengthInFeet = _useState2[1];

  var _useState3 = useState(parsedInitialValue && parsedInitialValue.inches.toString()),
      _useState4 = _slicedToArray(_useState3, 2),
      lengthInInches = _useState4[0],
      setLengthInInches = _useState4[1];

  var _useState5 = useState(parsedInitialValue ? {
    isValid: isValidNumber(parsedInitialValue.feet.toString())
  } : {}),
      _useState6 = _slicedToArray(_useState5, 2),
      feetInputValidation = _useState6[0],
      updateFeetInputValidation = _useState6[1];

  var _useState7 = useState(parsedInitialValue ? {
    isValid: isValidNumber(parsedInitialValue.inches.toString())
  } : {}),
      _useState8 = _slicedToArray(_useState7, 2),
      inchesInputValidation = _useState8[0],
      updateInchesInputValidation = _useState8[1];

  var handleFeetInputValue = function handleFeetInputValue(updatdFeetValue) {
    setLengthInFeet(updatdFeetValue);

    if (updatdFeetValue && isLengthValueInvalid(updatdFeetValue)) {
      updateFeetInputValidation({
        errorText: 'Plese enter a valid value for feet',
        isValid: false
      });
    } else {
      updateFeetInputValidation({
        errorText: undefined,
        isValid: true
      });
    }

    updateHeightValue(lengthInInches, updatdFeetValue);
  };

  var handleInchesInputValue = function handleInchesInputValue(updatedInchesValue) {
    setLengthInInches(updatedInchesValue);

    if (updatedInchesValue && isLengthValueInvalid(updatedInchesValue)) {
      updateInchesInputValidation({
        errorText: 'Please enter a valid value for inches',
        isValid: false
      });
    } else {
      updateInchesInputValidation({
        errorText: undefined,
        isValid: true
      });
    }

    updateHeightValue(updatedInchesValue, lengthInFeet);
  };
  /**
   * All numeric questions use the same regex to determine if the question is a valid number.
   * If either of the length fields are filled out, check them against the regex. Any invalid
   * input will submit `Invalid` back to the Numeric question handler. This is preference over
   * otherwise sending `isNaN * 12 + isNaN`.
   *
   * If both fields are present and valid, calculate the total height in inches from the two fields.
   *
   * If both fields are removed, send an empty string. If this question isn't required, the node
   * may now be valid.
   */


  var updateHeightValue = function updateHeightValue(inches, feet) {
    if (inches && isLengthValueInvalid(inches) || feet && isLengthValueInvalid(feet)) {
      onLengthUpdated('Invalid');
    } else if (inches || feet) {
      // If only one is present, default to `0` for the other so we can do the math
      var parsedFeet = feet || '0';
      var parsedInches = inches || '0';
      var heightInInches = feetToInches(parseInt(parsedFeet, 10), parseInt(parsedInches, 10));
      onLengthUpdated(heightInInches.toString());
    } else {
      onLengthUpdated('');
    }
  };

  return React.createElement("div", {
    className: styles.dualInputContainer
  }, React.createElement("div", {
    className: styles.dualInputWrapper
  }, React.createElement("div", {
    className: styles.input
  }, React.createElement(TextField, {
    type: "tel",
    disabled: disabled,
    error: fieldError || !!(feetInputValidation === null || feetInputValidation === void 0 ? void 0 : feetInputValidation.errorText),
    errorText: feetInputValidation === null || feetInputValidation === void 0 ? void 0 : feetInputValidation.errorText,
    autoFocus: false,
    label: "",
    labelHidden: true,
    placeholder: "Feet",
    unit: "ft",
    defaultValue: lengthInFeet ? lengthInFeet.toString() : undefined,
    onChange: function onChange(e) {
      return handleFeetInputValue(e.target.value);
    }
  })), React.createElement("div", {
    className: styles.input
  }, React.createElement(TextField, {
    type: "tel",
    disabled: disabled,
    name: "inches",
    error: fieldError || !!(inchesInputValidation === null || inchesInputValidation === void 0 ? void 0 : inchesInputValidation.errorText),
    errorText: inchesInputValidation === null || inchesInputValidation === void 0 ? void 0 : inchesInputValidation.errorText,
    autoFocus: false,
    label: "",
    labelHidden: true,
    placeholder: "Inches",
    unit: "in",
    defaultValue: lengthInInches ? lengthInInches.toString() : undefined,
    onChange: function onChange(e) {
      return handleInchesInputValue(e.target.value);
    }
  }))));
};

export default LengthInInches;
//# sourceMappingURL=index.js.map
